@import '../../../../../../../../constants/spacing.module.less';

.feature-name-cell {
  font-weight: 500;
  overflow-wrap: break-word;
  padding-left: @space-0;
  justify-content: flex-start;
}
